var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"content":_vm.cartItemCount,"value":_vm.cartItemCount > 0,"color":"primary","overlap":"","offset-x":"20","offset-y":"20"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-cart-outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }